(function($){
	/**************************************************************
		HEADER - HAMBURGER CLICK
	**************************************************************/
	var forEach=function(t,o,r){if("[object Object]"===Object.prototype.toString.call(t))for(var c in t)Object.prototype.hasOwnProperty.call(t,c)&&o.call(r,t[c],c,t);else for(var e=0,l=t.length;l>e;e++)o.call(r,t[e],e,t)};

	var hamburgers = document.querySelectorAll(".hamburger");
	if (hamburgers.length > 0) {
		forEach(hamburgers, function(hamburger) {
			hamburger.addEventListener("click", function() {
				this.classList.toggle("is-active");
				$('.mobile-nav').toggleClass('is-active');
				$('body').toggleClass('open--nav');
			}, false);
		});
	}

	$( ".mobile-nav__menu__content__nav > .menu-item-has-children > a > span" ).on( "click", function(e) {
		e.preventDefault();

		if ($(this).parent().parent().hasClass('open')) {
			$(this).parent().parent().removeClass('open');
		} else {
			$(".mobile-nav__menu__content__nav > .menu-item-has-children").removeClass('open');
			$(this).parent().parent().addClass('open');
		}
	});

	/**************************************************************
		FORMS - CUSTOM UPLOAD FILE CHANGE
	**************************************************************/
	document.addEventListener('DOMContentLoaded', () => {
		document.querySelectorAll('.form-wrap__field__upload input[type="file"]').forEach(input => {
			input.addEventListener('change', function () {
				const fileName = this.files[0]?.name || 'PDF or Word document';
				const uploadWrapper = this.closest('.form-wrap__field__upload');
				const fileNameSpan = uploadWrapper.querySelector('.form-wrap__field__upload__name');

				if (fileNameSpan) {
					fileNameSpan.textContent = fileName;
				}
			});
		});
	});


    // Scroll on click
    $(document).on('click', 'a[href^="#"]', function (event) {
        event.preventDefault();
        $('html, body').animate({
            scrollTop: $($.attr(this, 'href')).offset().top
        }, 1000);
    });


	// Slick Sliders
	/*$('#slider').slick({
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 700,
		dots: true,
		arrows: true,
        prevArrow:"<button type='button' class='slick-prev'><i class='fas fa-chevron-left'></i></button>",
        nextArrow:"<button type='button' class='slick-next'><i class='fas fa-chevron-right'></i></i></button>",
		infinite: true,
		slidesToShow: 2,
		slidesToScroll: 1,
        responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1
          }
        }
        ]
	});*/


    // Accordions
    $(function() {
        $('.accordion-answer').hide();
        $('.accordion-question:first').addClass('active').next().slideDown('slow');
        $('.accordion-question').click(function(){
            if($(this).next().is(':hidden')) {
                $('.accordion-question').removeClass('active').next().slideUp('slow');
                $(this).toggleClass('active').next().slideDown('slow');
            } else if($(this).next().is(':visible')) {
                $(this).toggleClass('active').next().slideUp('slow');
            }
        });
    });

	document.addEventListener( 'wpcf7mailsent', function( event ) {
		if (event.detail.contactFormId == 1280 || event.detail.contactFormId == 1568) {
			setTimeout( () => {
				window.location.href = '/contact/thank-you/';
			}, 500 ); // Wait for 0.5 second before redirect
		} else if (event.detail.contactFormId == 1315) {
			setTimeout( () => {
				window.location.href = '/about/careers/thank-you/';
			}, 500 ); // Wait for 0.5 second before redirect
		}
	}, false );



    //header on scroll

   /* $(window).scroll(function () {

        if( $(window).scrollTop() > 180 ) {
          $('#siteHeader').addClass('header-fixed');
          $logoAltURL = $('#company-alt-logo').attr('src');
          $('#company-alt-logo').fadeIn();
          $('#company-logo').hide();
          console.log($logoAltURL);
        }
        if( $(window).scrollTop() < 180 ) {
          $('#siteHeader').removeClass('header-fixed');
           $logoURL = $('#company-logo').attr('src');
           $('#company-logo').fadeIn();
           $('#company-alt-logo').hide();
           console.log($logoURL);
        }
     })

     //Parallax Animation
    var image = document.getElementsByClassName('obs-img');
          new trustPara(image, {
          maxTransition: 300
    })*/

    // Initiate aos animations
	//AOS.init();


	// Remove empty paragraphs
	$('p:empty:not([role])').remove();
})(jQuery);
